import { Close } from "@mui/icons-material";
import { Box, Dialog, DialogContent, DialogTitle, Divider, IconButton, Skeleton, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import { DIALOG_MAX_WIDTHS } from "src/Components/Common/Modal/ModalWidth";
import { formatDateTime24Hours } from "src/Utils/DateUtils";

import useFetch from "src/Components/Common/useFetch";
import arrow_right from "src/Graphics/AutomatedRecon/arrow_right.svg";
import { API_ENDPOINTS } from "src/Utils/ApiConstants/ApiUrlConstants";

export enum DR_HISTORY_FIELD {
  Issue = "Issue",
  Maker = "Maker",
  Approver = "Approver",
  Checker = "Checker",
  Attachment = "Attachment",
  Priority = "Priority",
  VendorRemark = "Vendor Remark",
  FinanceRemark = "Finance Remark",
  WarehouseRemark = "Warehouse Remark",
  ProcurementRemark = "Procurement Remark",
  ARBTPLRemark = "AR/BTPL Remark",
  GapReason = "Gap Reason",
  Action = "Action",
  Dependency = "Dependency",
  ResolutionStatus = "Resolution Status",
  DueDate = "Due date",
}
export enum DR_HISTORY_ACTION {
  Created = "Created",
  AutoAssigned = "Auto Assigned",
  Assigned = "Assigned",
  Updated = "Updated",
  AutoUpdated = "Auto Updated",
  Uploaded = "Uploaded",
  Added = "Added",
  Rejected = "Rejected",
  Approved = "Approved",
  Closed = "Closed",
}

const ViewHistoryDisputedEntries = ({
  selectedRowOfDisputedEntryForModal,
  openViewHistoryModal,
  setOpenViewHistoryModal,
}) => {
  const [loadingDisputeEntryHistory, setLoadingDisputeEntryHistory] = useState(false);
  const [disputeEntryHistoryList, setDisputeEntryHistoryList] = useState([]);

  const handleClose = () => {
    setOpenViewHistoryModal(false);
    setLoadingDisputeEntryHistory(false);
  };

  useEffect(() => {
    getTakeActionDataActionHistory(selectedRowOfDisputedEntryForModal?.gapId);
  }, []);

  const getTakeActionDataActionHistory = async (gapId) => {
    await useFetch(API_ENDPOINTS.FETCH_DR_ENTRIES_HISTORY(gapId).url, "GET", {
      failureMessage: API_ENDPOINTS.FETCH_DR_ENTRIES_HISTORY(gapId).failureMessage,
      thenCallBack: (response) => {
        setDisputeEntryHistoryList(response.data.data);
      },
      catchCallBack: () => {},
    });
  };

  return (
    <>
      <Dialog open={openViewHistoryModal} maxWidth={DIALOG_MAX_WIDTHS.SM} fullWidth>
        <DialogTitle className="dialog-title">
          <div className="heading-m">{selectedRowOfDisputedEntryForModal?.businessPartnerName || ""}</div>
          <div className="vertical_center_align">
            <IconButton onClick={handleClose}>
              <Close />
            </IconButton>
          </div>
        </DialogTitle>

        <DialogContent dividers sx={{ p: 2 }}>
          <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
            {/* loadingHistory add later */}
            {loadingDisputeEntryHistory ? (
              <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
                <Skeleton variant="rounded" width="100%" height={40} />
                <Skeleton variant="rounded" width="100%" height={40} />
                <Skeleton variant="rounded" width="100%" height={40} />
                <Skeleton variant="rounded" width="100%" height={40} />
              </Box>
            ) : (
              disputeEntryHistoryList.map((item: any, index) => {
                let actionType = "";
                // if (item.actionOwner === ActorTypesForRecon.ReconUser) {
                if (item.action === DR_HISTORY_ACTION.Created) actionType = "Created";
                if (item.action === DR_HISTORY_ACTION.AutoAssigned) actionType = "Auto assigned";
                if (item.action === DR_HISTORY_ACTION.Assigned) actionType = "Assigned";
                if (item.action === DR_HISTORY_ACTION.Updated) actionType = "Updated the";
                if (item.action === DR_HISTORY_ACTION.Uploaded) actionType = "Uploaded the";
                if (item.action === DR_HISTORY_ACTION.Added) actionType = "Added";
                if (item.action === DR_HISTORY_ACTION.Rejected) actionType = "Rejected the";
                if (item.action === DR_HISTORY_ACTION.Approved) actionType = "Approved the";
                if (item.action === DR_HISTORY_ACTION.Closed) actionType = "Closed";
                if (item.action === DR_HISTORY_ACTION.Updated) actionType = "Updated";
                if (item.action === DR_HISTORY_ACTION.AutoUpdated) actionType = "Auto updated";

                // } else if (item.actionOwner === ActorTypesForRecon.Partner) {
                //   if (item.action === DR_HISTORY_ACTION.Raised) actionType = "Query raised by";
                //   if (item.action === DR_HISTORY_ACTION.Received) actionType = "Response received by";
                //   if (item.action === DR_HISTORY_ACTION.Updated) actionType = "Response updated by";
                // }

                return (
                  <Box key={index}>
                    <Box sx={{ paddingY: 1 }}>
                      {/* this is for the first row of the history item
                    e.g. Mukul deleted the Attachment
                    e.g. Mukul updated the Due Date
                    e.g. Mukul created the task
                     */}
                      <Box sx={{ display: "flex", flexDirection: "row", justifyContent: "space-between" }}>
                        {/* {item.actionOwner === ActorTypesForRecon.ReconUser ? ( */}
                        <p>
                          {item.action === DR_HISTORY_ACTION.Created || item.action === DR_HISTORY_ACTION.Closed ? (
                            <span className="fs_14 fw_600">{`${item.field} ${actionType}`}</span>
                          ) : (
                            <span className="fs_14 fw_600">{`${item.actionOwner} ${actionType} ${item.field}`}</span>
                          )}
                        </p>

                        <Typography variant="subtitle2" sx={{ fontWeight: "400", color: "rgba(0, 0, 0, 0.6)" }}>
                          {item.timestamp && formatDateTime24Hours(item.timestamp)}{" "}
                        </Typography>
                      </Box>
                      {/* this is for the second row of the history item*/}
                      {item.field === DR_HISTORY_FIELD.Attachment ? (
                        <Box sx={{ display: "flex", flexDirection: "row" }}>
                          <Typography
                            variant="subtitle2"
                            sx={{
                              fontWeight: "400",
                              fontSize: "12px",
                              color: "rgba(0, 0, 0, 0.6)",
                              alignSelf: "center",
                              wordBreak: "break-word",
                            }}
                          >
                            {item.field === DR_HISTORY_FIELD.Attachment ? "Filename: " : ""}
                          </Typography>
                          <Typography
                            variant="subtitle2"
                            sx={{
                              marginLeft: 1,
                              fontWeight: "400",
                              fontSize: "12px",
                              alignSelf: "center",
                              wordBreak: "break-word",
                            }}
                          >
                            {item.newValue}
                          </Typography>
                        </Box>
                      ) : (
                        <Box sx={{ display: "flex", flexDirection: "row" }}>
                          {item.oldValue && (
                            <>
                              <Typography
                                variant="subtitle2"
                                sx={{
                                  marginRight: 1,
                                  fontWeight: "400",
                                  fontSize: "12px",
                                  color: "rgba(0, 0, 0, 0.6)",
                                  alignSelf: "center",
                                  wordBreak: "break-word",
                                }}
                              >
                                {item.oldValue || ""}
                              </Typography>
                              <img src={arrow_right} alt="arrow icon" />
                            </>
                          )}

                          <Typography
                            variant="subtitle2"
                            sx={{
                              marginLeft: 1,
                              fontWeight: "400",
                              fontSize: "12px",
                              alignSelf: "center",
                              wordBreak: "break-word",
                            }}
                          >
                            {item.newValue || ""}
                          </Typography>
                        </Box>
                      )}
                    </Box>
                    <Divider />
                  </Box>
                );
              })
            )}
          </Box>
        </DialogContent>
      </Dialog>
    </>
  );
};

export default ViewHistoryDisputedEntries;
